const defGradient = [
  'rgba(102, 255, 0, 0)',
  'rgba(102, 255, 0, 1)',
  'rgba(147, 255, 0, 1)',
  'rgba(193, 255, 0, 1)',
  'rgba(238, 255, 0, 1)',
  'rgba(244, 227, 0, 1)',
  'rgba(249, 198, 0, 1)',
  'rgba(255, 170, 0, 1)',
  'rgba(255, 113, 0, 1)',
  'rgba(255, 57, 0, 1)',
  'rgba(255, 0, 0, 1)'
]

const blueRed = [
  'rgba(0, 255, 255, 0)',
  'rgba(0, 255, 255, 1)',
  'rgba(0, 191, 255, 1)',
  'rgba(0, 127, 255, 1)',
  'rgba(0, 63, 255, 1)',
  'rgba(0, 0, 255, 1)',
  'rgba(0, 0, 223, 1)',
  // 'rgba(0, 0, 191, 1)',
  // 'rgba(0, 0, 159, 1)',
  'rgba(0, 0, 127, 1)',
  'rgba(63, 0, 91, 1)',
  'rgba(127, 0, 63, 1)',
  'rgba(191, 0, 31, 1)',
  'rgba(255, 0, 0, 1)'
]

/**
 *
 * @param {Number[]} startColor [r, g, b]
 * @param {Number[]} endColor
 * @param {Number} steps
 * @returns
 */
function getGradient(startColor, endColor, steps=10) {
  let [r0, g0, b0] = startColor
  let [r1, g1, b1] = endColor

  let result = [
    [r0, g0, b0]
  ]

  for ( let i = 1; i <= steps; i++ ) {
    let pct = i / steps
    let ri = Math.floor(r0 + pct * (r1 - r0))
    let gi = Math.floor(g0 + pct * (g1 - g0))
    let bi = Math.floor(b0 + pct * (b1 - b0))
    result.push([ri, gi, bi])
  }

  result = result.map(x => {
    return `rgba(${x[0]}, ${x[1]}, ${x[2]}, 1)`
  })

  result.unshift('rgba(0, 0, 0, 0)')

  return result
}

const red = getGradient([235, 145, 138], [255, 38, 5])
const green = getGradient([207, 255, 207], [0, 255, 0])
const blue = getGradient([130, 220, 255], [0, 25, 250])

module.exports = {
  defGradient,
  blueRed,
  red,
  green,
  all: [defGradient, blueRed, red, green, blue]
}